import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement("path", { fill: "#E94B35", d: "M0 0h32v32H0z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M1.334 1.333h29.333v29.334H1.334z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M9.334 15.63C9.334 10.56 16 6 16 6s6.667 4.172 6.667 9.63C22.667 21.698 16 26 16 26s-6.666-4.688-6.666-10.37"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#C2E7FF",
      fillRule: "evenodd",
      d: "M16.419 24.451a19 19 0 0 0 2.174-2.033c1.932-2.125 3.074-4.421 3.074-6.788 0-2.08-1.132-4.18-3.053-6.167a19.4 19.4 0 0 0-2.592-2.237q-.206.158-.434.342a22 22 0 0 0-2.192 2.03c-1.926 2.05-3.062 4.123-3.062 6.032 0 2.196 1.145 4.465 3.082 6.653a21.3 21.3 0 0 0 2.605 2.476q.19-.143.398-.308",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M10.754 18c.497 1.434 1.415 2.875 2.662 4.283a21.3 21.3 0 0 0 2.605 2.476q.19-.143.398-.308a19 19 0 0 0 2.174-2.033c1.28-1.407 2.212-2.89 2.697-4.418z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C8431",
      fillRule: "evenodd",
      d: "M21.498 17.212c-1.759.327-6.529.105-6.529.105l-.302.683 6.62.006q.126-.395.211-.794",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M13.415 22.283a16 16 0 0 1-1.558-2.047c1.602-.037 4.49.747 4.586 1.479.03.232-2-.061-2.902.708zm1.514.376c.65-.445 2.301.03 2.301-1.04 0-1.277-1.425-1.05-1.622-1.247-.118-.119.855-.683 1.475-.505s2.006-.178 2.626-.505c.342-.18.81-.252 1.16-.28-.527 1.147-1.3 2.263-2.276 3.336a18.7 18.7 0 0 1-2.572 2.34q-.199-.158-.417-.343a22 22 0 0 1-1.317-1.209 4 4 0 0 1 .642-.547",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#7B4800",
      fillRule: "evenodd",
      d: "M14.999 18.333s.105 1-1.512 1-1.484-.85-1.484-.85.663.1 1.484.1c.822 0 1.512-.25 1.512-.25",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M15.013 9c.286 1.033.647 2.283.647 2.283-.26-.32-1.282-1.028-1.865-.99.645.424 1.52 1.479 1.52 1.479.003 0-2.047-1.173-3.315.832 1.069-.604 2.843-.498 2.843-.498s-1.573.519-1.774 1.766c0 0 1.109-1.157 2.106-1.278 0 0-.862 1.422-.484 2.406.323-.47.608-2.255 1.309-2.396.48.12 1.1 2.207 1.1 2.207s.332-1.448-.655-2.236c1.357.17 2.368 1.328 2.368 1.328s.294-1.608-2.045-1.824c0 0 1.486-.387 2.232-.203-.474-.866-2.41-.4-2.41-.4.127-.339 1.664-1.276 1.664-1.276-1.074.03-1.758.624-2.062 1.2.01-.316-.532-2.13-1.179-2.4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#7B4800",
      fillRule: "evenodd",
      d: "m15.853 12.546.226-.012c-.106 1.763-.007 4.29.285 5.226.497 1.59 1.945 2.201 2.289 2.354.195.086.12.443-.271.419s-1.757-.851-2.229-2.33c-.631-1.984-.325-5.45-.3-5.657",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M12.719 16.333s1.156.44 1.615 1.976c0 0-1.06-.22-1.663.024h-.337s.578-.853.385-2",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagGum = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagGum_default = SvgFlagGum;

export { FlagGum_default as default };
